// src/theme/productoResolver.js
//
// Resuelve cómo se llama el producto en cada deploy.
//
// Fenagro quiere mostrarlo como "Aulas Virtuales" (contexto institucional).
// ComuniSer lo muestra como "ComuniSer" directo (contexto marca blanca).
// Multi-tenant Redeprog usa "EducaT" por defecto, salvo que la
// organización traiga un nombre propio desde el backend.
//
// Precedencia:
//   1. producto_nombre explícito del backend (si viene en /organizacion/actual).
//   2. Alias según slug de la organización.
//   3. Alias según modo de operación.
//   4. Default "EducaT".

const ALIAS_POR_SLUG = {
  fenagro:   { nombre: 'Aulas Virtuales',  nombreCorto: 'Aulas',    etiquetaLogo: null },
  comuniser: { nombre: 'ComuniSer',         nombreCorto: 'ComuniSer', etiquetaLogo: null },
};

const ALIAS_POR_MODO = {
  fenagro:  { nombre: 'Aulas Virtuales', nombreCorto: 'Aulas',  etiquetaLogo: null },
  redeprog: { nombre: 'EducaT',          nombreCorto: 'EducaT', etiquetaLogo: { prefijo: 'ET', raiz: 'EducaT' } },
};

const DEFAULT = { nombre: 'EducaT', nombreCorto: 'EducaT', etiquetaLogo: { prefijo: 'ET', raiz: 'EducaT' } };

/**
 * @param {{modoOperacion?: string, organizacion?: {slug?: string, producto_nombre?: string, productoNombre?: string}}} ctx
 * @returns {{nombre: string, nombreCorto: string, etiquetaLogo: {prefijo:string,raiz:string}|null}}
 */
export function resolveProducto({ modoOperacion, organizacion }) {
  // 1. Nombre explícito del backend
  const nombreBackend = organizacion?.producto_nombre || organizacion?.productoNombre;
  if (nombreBackend && typeof nombreBackend === 'string' && nombreBackend.trim()) {
    return {
      nombre:        nombreBackend.trim(),
      nombreCorto:   nombreBackend.trim(),
      etiquetaLogo:  null,
    };
  }

  // 2. Alias por slug de organización
  const slug = organizacion?.slug?.toLowerCase?.();
  if (slug && ALIAS_POR_SLUG[slug]) return ALIAS_POR_SLUG[slug];

  // 3. Alias por modo
  const modo = (modoOperacion || '').toLowerCase();
  if (ALIAS_POR_MODO[modo]) return ALIAS_POR_MODO[modo];

  // 4. Default
  return DEFAULT;
}
